import { ActionsPopover, Button, PencilIcon, useAppContext } from "@dit/core-frontend"
import { Delete } from "@mos-cat/ds-icons"
import React from "react"
import { useEditorCommentsContext } from "."
import { useZoneContext } from "@src/components/contexts/ZoneContext"

export const CommentActions = ({ setIsEditComment, comment }) => {
  const { user } = useAppContext()
  const { deleteComment } = useEditorCommentsContext()
  const { zone, checkZonePermission } = useZoneContext()
  const isEditable = user.id === comment.user?.id || checkZonePermission("PAGE_COMMENTS_ALL_EDIT")
  const isDeletable =
    user.id === comment.user?.id || checkZonePermission("PAGE_COMMENTS_ALL_DELETE")
  return (
    <>
      {(isEditable || isDeletable) && (
        <ActionsPopover>
          {(buttonProps, hidePopover) => (
            <>
              {isEditable && (
                <Button
                  {...buttonProps}
                  kind="borderless"
                  onClick={() => {
                    setIsEditComment(true)
                    hidePopover()
                  }}
                >
                  <PencilIcon color="currentColor" />
                  Редактировать
                </Button>
              )}
              {isDeletable && (
                <Button
                  {...buttonProps}
                  kind="borderless"
                  onClick={() => {
                    deleteComment(comment.id, comment.textBlockId, comment?.replyTo?.id)
                    hidePopover()
                  }}
                >
                  <Delete color="currentColor" />
                  Удалить
                </Button>
              )}
            </>
          )}
        </ActionsPopover>
      )}
    </>
  )
}
